
import React, { useState } from 'react'
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap'
import { useDispatch } from 'react-redux'

import { removeConstraint, updateConstraint } from '@/Services/ProgrammationManagerService'
import useTranslation from '@/Hooks/UseTranslation'
import { useProgrammation } from '@/Hooks/UseProgrammation'
import { useTeams } from '@/Hooks/UseTeam'
import { updateConstraintsAction } from '@/Redux/Actions/ProgrammationManagerActions'

import InputSelect from '../../components/InputSelect'
import ToggleGroupIcon from '../../../AnimatedIcons/ToggleGroupIcon/ToggleGroupIcon'

import Spinner from '@/Components/SvgImages/Spinner/Spinner'
import TrashIcon from '@/Components/SvgImages/TrashIcon'
import Checkbox from '@/Components/SvgImages/Checkbox'
import Textarea from '../../components/Textarea'
import RestrictionCommentInput from '../../components/RestrictionCommentInput'
import RestrictionComment from '../../components/RestrictionComment'
import InputDate from '../../components/InputDate'
import InputDropdown from '../../components/InputDropdown/InputDropdown'
import InputDropdownUser from '../../components/InputDropdown/InputDropdownUser'

import './ConstraintItem.scss'

const ConstraintItem = ({ constraint, subTask, canDelete = true }: any) => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { itemOpened, setEditingItem, patchItemOpened } = useProgrammation()

  const familiesOptions = [
    { _id: 'general', name: t('CONSTRAINT_CREATOR:FamilyGeneral') },
    { _id: 'coordination', name: t('CONSTRAINT_CREATOR:FamilyCoordination') },
    { _id: 'resource', name: t('CONSTRAINT_CREATOR:FamilyResource') },
    { _id: 'time', name: t('CONSTRAINT_CREATOR:FamilyTime') },
    { _id: 'space', name: t('CONSTRAINT_CREATOR:FamilySpace') },
    { _id: 'design', name: t('CONSTRAINT_CREATOR:FamilyDesign') },
    { _id: 'logistic', name: t('CONSTRAINT_CREATOR:FamilyLogistic') },
  ]

  // const { users } = useSelector((state: any) => state.ProgrammationReducer)
  const { users, allInternalProfiles } = useTeams()

  const [ checked, setChecked ] = useState(constraint.checked)
  const [ description, setDescription ] = useState(constraint.content)
  const [ family, setFamily ] = useState(constraint.family)
  const [ responsable, setResponsable ] = useState(constraint.responsable?._id || '')
  const [ promiseDate, setPromiseDate ] = useState(constraint.promiseDate || '')
  const [ requiredDate, setRequiredDate ] = useState(constraint.requiredDate || '')
  const [ releaseDate, setReleaseDate ] = useState(constraint.releaseDate || '')
  const [ isCollapsed, setIsCollapsed ] = useState(true)
  const [ deleting, setDeleting ] = useState(false)

  const [ comments, setComments ] = useState(constraint.comments)

  const task = subTask || itemOpened

  const handleUpdate = async (constraint: any) => {

    setEditingItem(true)

    const [ error, data ] = await updateConstraint(task._id, constraint)

    setEditingItem(false)

    if (error) {
      return console.log(error)
    }

    if (!subTask) {

      patchItemOpened({
        restrictions: itemOpened.restrictions.map((c: any) => c._id === constraint._id ? constraint : c)
      })
    } else {
      const subTasks = itemOpened.subTasks

      subTasks.forEach((subTask: any) => {

        if (subTask._id === task._id) {

          subTask.restrictions = subTask.restrictions.map((c: any) => c._id === constraint._id ? constraint : c)
        }
      })

      patchItemOpened({
        subTasks
      })
    }

    dispatch(updateConstraintsAction({ task: data.task, parentTask: data.parentTask }))
  }

  const handleToggleCheckbox = (checked: boolean) => {

    setChecked(checked)

    handleUpdate({
      ...constraint,
      family,
      responsable,
      checked,
    })
  }

  const handleDescriptionChange = (description: string) => {

    setDescription(description)

    handleUpdate({
      ...constraint,
      content: description,
      family,
      responsable,
      checked,
    })
  }

  const handleFamilyChange = (family: string) => {

    setFamily(family)

    handleUpdate({
      ...constraint,
      family,
      responsable,
      checked,
    })
  }

  const handleResponsableChange = (responsable: string) => {

    console.log('responsable', responsable)

    const foundInUsers = users.find((u: any) => u._id === responsable)
    const foundInInternalProfiles = allInternalProfiles.find((u: any) => u._id === responsable)

    let responsableModel

    if (foundInUsers) {
      responsableModel = 'User'
    } else if (foundInInternalProfiles) {
      responsableModel = 'InternalProfile'
    }

    setResponsable(responsable)

    handleUpdate({
      ...constraint,
      family,
      responsable,
      responsableModel,
      checked,
    })
  }

  const handleChangeDate = (date: string, field: string) => {

    switch(field) {
      case 'promiseDate':
        setPromiseDate(date)
        break
      case 'requiredDate':
        setRequiredDate(date)
        break
      case 'releaseDate':
        setReleaseDate(date)
        break
    }

    handleUpdate({
      ...constraint,
      family,
      responsable,
      checked,
      [field]: date,
    })
  }

  const handleDelete = async () => {

    setEditingItem(true)
    setDeleting(true)

    const [ error, data ] = await removeConstraint(task._id, constraint._id)

    setEditingItem(false)
    setDeleting(false)

    if (error) {
      return console.log(error)
    }

    if (!subTask) {

      patchItemOpened({
        restrictions: itemOpened.restrictions.filter((c: any) => c._id !== constraint._id)
      })
    } else {

      const subTasks = itemOpened.subTasks

      subTasks.forEach((subTask: any) => {

        if (subTask._id === task._id) {

          subTask.restrictions = subTask.restrictions.filter((c: any) => c._id !== constraint._id)
        }
      })

      patchItemOpened({
        subTasks
      })
    }

    dispatch(updateConstraintsAction({ task: data.task, parentTask: data.parentTask }))
  }

  console.log('responsable',responsable)

  return (
    <div className='constraint-item'>
      <div className="contraint-item-header">
        <div className="constraint-item-header-actions">
          <button
            className="constraint-item-button"
            onClick={() => handleToggleCheckbox(!constraint.checked)}
          >
            <Checkbox
              height={18}
              width={18}
              checked={checked}
            />
          </button>
        </div>
        <div className="constraint-item-name"
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          <div className={`constraint-item-family-badge constraint-item-family-badge-${constraint.family}`}>
            {familiesOptions.find((f: any) => f._id === constraint.family)?.name}
          </div>
          <div className="constraint-item-name-text">
            {constraint.description}
          </div>
        </div>
        <div className="constraint-item-header-actions">
          <button
            className={`constraint-item-button ${isCollapsed ? 'collapsed' : ''}`}
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            <ToggleGroupIcon
              size={20}
              isOpen={!isCollapsed}
            />
          </button>
        </div>
      </div>
      <div className={`constraint-item-body scroller ${isCollapsed ? 'collapsed' : ''}`}>
        <div className="constraint-item-body-content">
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <button
              className="btn btn-danger"
              onClick={handleDelete}
              disabled={deleting}
            >
              {deleting && (
                <>
                  <Spinner
                    height={20}
                    width={20}
                    fill="#e21c1c"
                  /> {t('CONSTRAINT_CREATOR:DeleteButton')}
                </>
              )}
              {!deleting && (
                <>
                  <TrashIcon
                    height={20}
                    width={20}
                    color="#e21c1c"
                  /> {t('CONSTRAINT_CREATOR:DeleteButton')}
                </>
              )}
            </button>
          </div>
          <FormGroup>
            <FormLabel>
              {t('CONSTRAINT_CREATOR:LabelDescription')}
            </FormLabel>
            <Textarea
              placeholder="Descripción"
              value={description}
              onChange={(e: any) => handleDescriptionChange(e)}
              style={{ maxHeight: 60, resize: 'none' }}
            />
          </FormGroup>
          <FormGroup>
            <FormLabel>
              {t('CONSTRAINT_CREATOR:LabelFamily')}
            </FormLabel>
            <InputSelect
              // placeholder="Family"
              value={family}
              options={familiesOptions}
              onChange={(e: any) => handleFamilyChange(e)}
            />
          </FormGroup>
          <FormGroup>
            <FormLabel>
              {t('CONSTRAINT_CREATOR:LabelAssignee')}
            </FormLabel>
            <InputDropdown
              value={responsable}
              placeholder="Responsible"
              options={[ ...users, ...allInternalProfiles ]}
              renderItem={(option: any) => (
                <InputDropdownUser
                  user={option}
                  isSelected={option._id === responsable}
                />
              )}
              onChange={(user_id: any) => handleResponsableChange(user_id)}
            />
            {/* <InputSelect
              placeholder="Responsible"
              value={responsable}
              options={users.map((u: any) => ({ _id: u._id, name: `${u.name} ${u.surname}` }))}
              onChange={(e: any) => handleResponsableChange(e)}
            /> */}
          </FormGroup>
          <Row className='mb-4'>
            <FormGroup as={Col} sm={4}>
              <FormLabel>
                {t('CONSTRAINT_CREATOR:LabelPromiseDate')}
              </FormLabel>
              <InputDate
                value={promiseDate}
                onChange={(e: any) => handleChangeDate(e, 'promiseDate')}
              />
            </FormGroup>
            <FormGroup as={Col} sm={4}>
              <FormLabel>
                {t('CONSTRAINT_CREATOR:LabelRequiredDate')}
              </FormLabel>
              <InputDate
                value={requiredDate}
                onChange={(e: any) => handleChangeDate(e, 'requiredDate')}
              />
            </FormGroup>
            <FormGroup as={Col} sm={4}>
              <FormLabel>
                {t('CONSTRAINT_CREATOR:LabelReleaseDate')}
              </FormLabel>
              <InputDate
                value={releaseDate}
                onChange={(e: any) => handleChangeDate(e, 'releaseDate')}
              />
            </FormGroup>
          </Row>
          <div>
            <RestrictionCommentInput taskId={task._id} restrictionId={constraint._id} onCommentsUpdated={setComments} />
            <div className="constraint-item-comments">
              {[...comments].reverse().map((comment: any, i: number) => (
                <div key={comment._id}>
                  <RestrictionComment
                    item={comment}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConstraintItem
